import { TReconnectOptions } from '@ConfigLoader/Configs';

export interface IUseErrorManagerState {
    tryAttepmt: number;
    maxTries: number;
    retryTimeout: number;
}

export const IUseErrorManagerDefaults = {
    tryAttepmt: 0,
    maxTries: 5,
    retryTimeout: 2000
};
